var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6076 9.84701L18.6154 9.84074C19.3688 9.23526 20.4703 9.35512 21.0758 10.1085L29.1372 20.1385C29.428 20.1661 29.7145 20.2083 29.9961 20.2643C30.0814 19.7085 30.1827 19.1845 30.2727 18.7201C30.2869 18.6566 30.3025 18.5848 30.3198 18.5058C30.6317 17.0775 31.4629 13.2717 33.2727 13.1201C33.8351 13.1605 34.371 13.3746 34.8063 13.7329C35.2417 14.0912 35.5549 14.576 35.7027 15.1201C35.9722 16.0385 35.5975 16.7088 35.1458 17.5171C34.7761 18.1786 34.3547 18.9324 34.1927 19.9901C34.0412 20.9834 34.1739 21.8751 34.4231 22.6724C35.9203 24.2077 36.8427 26.3062 36.8427 28.6201C36.8427 33.3255 33.0282 37.1401 28.3227 37.1401C25.7238 37.1401 23.3967 35.9764 21.8339 34.1417L11.2726 26.2524C10.4983 25.6739 10.3395 24.5773 10.9179 23.803L10.9239 23.795C11.5023 23.0207 12.5989 22.8619 13.3732 23.4403L19.8106 28.2491C19.8205 28.0185 19.8396 27.7902 19.8674 27.5647L11.4827 19.1799C11.1554 18.8502 10.9717 18.4045 10.9717 17.9399C10.9717 17.4754 11.1554 17.0296 11.4827 16.6999C11.8124 16.3726 12.2581 16.1889 12.7227 16.1889C13.1873 16.1889 13.633 16.3726 13.9627 16.6999L21.2023 23.9396C21.3413 23.7286 21.4894 23.5242 21.6461 23.3268L12.6862 13.9672C12.0178 13.2691 12.042 12.1613 12.7402 11.4929L12.7474 11.486C13.4456 10.8177 14.5533 10.8418 15.2217 11.54L24.3535 21.0792C24.598 20.9502 24.8496 20.8327 25.1075 20.7276L18.3399 12.3074C17.7344 11.554 17.8543 10.4525 18.6076 9.84701Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97269 32.4901C6.79126 31.8084 5.76032 30.8942 4.94218 29.8028C4.12404 28.7113 3.53569 27.4654 3.21269 26.1401C2.78516 24.1237 3.00565 22.0238 3.84269 20.1401",
    stroke: "#575656",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66275 29.6402C8.85481 29.1788 8.14916 28.5579 7.58873 27.8153C7.0283 27.0726 6.62479 26.2237 6.40275 25.3202C6.10464 23.9427 6.25532 22.5059 6.83275 21.2202",
    stroke: "#575656",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0828 2C22.4461 2.03476 23.7881 2.34607 25.0275 2.91505C26.2668 3.48403 27.3777 4.29882 28.2928 5.31C29.6452 6.88435 30.4582 8.85027 30.6128 10.92",
    stroke: "#575656",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9426 5.31006C21.8706 5.33392 22.7841 5.5456 23.628 5.93231C24.4719 6.31903 25.2287 6.87275 25.8526 7.56006C26.7567 8.63955 27.2989 9.97578 27.4026 11.3801",
    stroke: "#575656",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17,
    y1: 4.50012,
    x2: 24.717,
    y2: 31.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEF86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC72E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandIcon);
export default __webpack_public_path__ + "static/media/hand_icon.0b2e2b52de1efbb2f63fb3ab10340b65.svg";
export { ForwardRef as ReactComponent };